module.exports = "/images/bannerFour.jpg";